<template>
  <div class="starCounterContainer">
    <div class="starCounterAnimationHolder" :class="{ jiggle: jiggle }">
      <img src="@/assets/images/StarBag.svg" alt="" class="no-select" />
    </div>
    <div class="counter no-select">
      <Transition name="switch">
        <span :key="stars" class="count"> {{ stars }}</span>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import type { Ref } from 'vue'
// Store
import { useDataStore } from '@/stores/DataStore'

// Helpers
import { useTimeout } from '@/utils/helpers'

const dataStore = useDataStore()
const { stars } = storeToRefs(dataStore)
const { setManagedTimeout } = useTimeout()

const jiggle: Ref<boolean> = ref(false)

watch(stars, () => {
  addJiggle()
})

function addJiggle() {
  jiggle.value = true
  setManagedTimeout(() => {
    jiggle.value = false
  }, 2000)
}
</script>

<style lang="scss">
.jiggleBtn {
  padding: 0.5rem;
  border: 1px solid #000;
}

.switch-enter-active,
.switch-leave-active {
  transition: transform 0.5s;
}

.switch-enter-from {
  position: absolute;
  transform: translateY(-100%);
}
.switch-leave-to {
  position: absolute;
  transform: translateY(100%);
}

.starCounterContainer {
  position: relative;

  .starCounterAnimationHolder {
    position: absolute;
    left: -2.5rem;
    top: -1.5rem;
    padding: 0;
    width: 4.75rem;
    height: 4.75rem;
    z-index: 2;

    img {
      width: 100%;
      height: 100%;
    }

    &.jiggle {
      @include animation(jiggle 0.5s 2);
    }
  }

  .counter {
    width: 8.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: flex-end;
    text-align: right;
    overflow-y: hidden;
    position: relative;
    z-index: 1;
    border-radius: 5px;
    background: rgb(50, 52, 68, 0.6);
    .count {
      display: flex;
      align-items: center;
      font-size: 1.5rem;
      margin-right: 1rem;
      color: #ffffff;
      font-weight: bold;
      height: 100%;
      overflow-y: hidden;
    }
  }
}
@include keyframes(jiggle) {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(5deg);
  }
  75% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
